export default __webpack_public_path__ + "static/media/Slide29.3674b60c.jpg";